/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Draggable from 'react-draggable';

import Paper, { PaperProps } from '@mui/material/Paper';
import Dialog, { DialogProps } from '@mui/material/Dialog';

type DraggablePaperProps = PaperProps & {
  handleId?: string;
};

const DraggablePaper = ({
  handleId,
  ...paperProps
}: DraggablePaperProps) => {
  const nodeRef = React.useRef<HTMLDivElement>(null);
  return (
    <Draggable
      nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
      handle={`#${handleId}`}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        {...paperProps}
        ref={nodeRef}
        sx={{
          [`& #${handleId}`]: { cursor: 'move' },
          ...paperProps.sx,
        }}
      />
    </Draggable>
  );
};

const DraggableDialog = ({
  handleId,
  ...dialogProps
}: DialogProps & {
  handleId: string;
}) => (
  <Dialog
    {...dialogProps}
    PaperComponent={DraggablePaper}
    slotProps={{
      ...dialogProps.slotProps,
      paper: {
        handleId,
      } satisfies DraggablePaperProps,
    } as DialogProps['slotProps']}
  />
);

export default DraggableDialog;
